<template>
  <div class="workspaceProfileLayout">
    <div style="padding-right: 30px">
      <navbar></navbar>
      <div style="margin-top: 50px">
        <div class="d-flex" style="padding-top: 20px; padding-bottom: 20px">
          <div
            style="margin-right: 10px; color: #5445f3; cursor: pointer"
            @click="$router.go(-1)"
          >
            <i class="fas fa-arrow-left"></i>
          </div>
          <div class="workspaceProfileTitle" style="display: contents">
            profile
          </div>
        </div>
        <div class="row w-100 ml-0 mr-0">
          <div class="col-4 pl-0">
            <div class="d-flex justify-content-center">
              <div
                class="workspaceProfileEditIconOuterLayout"
                style="cursor: pointer"
                @click="$refs.workspaceProfileLogo.click()"
              >
                <div class="workspaceProfileLogoEditIconLayout">
                  <div class="workspaceProfileLogoEditIconInnerLayout">
                    <i class="fas fa-pencil-alt"></i>
                    <input
                      type="file"
                      ref="workspaceProfileLogo"
                      @change="handleFile"
                      class="hidden"
                      accept="image/*"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="workspaceProfileLogoSection">
              <div style="padding-top: 30px; padding-bottom: 30px">
                <div class="workspaceProfileLogo">
                  <b-avatar
                    :text="avatarText"
                    class="align-baseline profileAvatar"
                    :style="`background:${backgroundColor};min-width:100%;min-height:100%;border-radius:50%;`"
                    :src="avatarLogo"
                  ></b-avatar>
                </div>
              </div>
              <div>
                <div class="">
                  <div style="padding: 10px 30px 0px 30px">
                    <table class="workspaceProfileTable">
                      <tr v-for="field in workspaceFields" :key="field.label">
                        <th style="width: 70%">{{ field.label }}</th>
                        <td v-html="field.value">
                          {{}}
                          <!-- <span
                      style="line-height: 1.5;display: inline-block;max-width: 100%;"
                      v-html="field.value"
                      >{{}}</span>-->
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row w-100 ml-0 mr-0 workspaceProfileBoxesOuterLayout">
                <div
                  class="col-4"
                  v-for="(item, index) in boxesArray"
                  :key="index"
                >
                  <div class="workspaceProfileBoxesInnerLayout">
                    <div style="margin-top: 15px; margin-bottom: 15px">
                      <div
                        class="d-flex justify-content-center"
                        style="margin-bottom: 4px"
                      >
                        <div class="workspaceProfileBoxesTitle">
                          {{ item.label }}
                        </div>
                      </div>
                      <div class="d-flex justify-content-center">
                        <div class="workspaceProfileBoxesValue">
                          {{ item.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-8 pr-0">
            <div class="workspaceProfileLogoSection">
              <div style="padding: 30px 30px 0px 30px">
                <table class="workspaceProfileTable">
                  <tr
                    v-for="field in workspaceProfileTableFields"
                    :key="field.label"
                  >
                    <th>{{ field.label }}</th>
                    <td
                      v-html="field.value"
                      v-if="field.label != 'Connected Email'"
                    >
                      {{}}
                      <!-- <span
                      style="line-height: 1.5;display: inline-block;max-width: 100%;"
                      v-html="field.value"
                      >{{}}</span>-->
                    </td>
                    <td v-else>
                      <div>
                        <div class="connectedEmailText">
                          Like insurance for your portfolio, automatically send
                          pitch decks, deal docs, and tax info to your fiifi
                          workspace from outside your fiifi account and from
                          your email. Use this unique email to share with scouts
                          and team members.
                        </div>
                        <div
                          class="connectedEmailText"
                          style="margin-top: 15px"
                        >
                          Emails that are logged to fiifi using the BCC or
                          forwarding address will include the attachments in the
                          email (email content coming soon!).
                        </div>
                        <div
                          class="connectedEmailText"
                          style="margin-top: 15px"
                        >
                          The attached will automatically be added to the
                          notification center, the sender to the attribution
                          section, and added to its associated company.
                        </div>
                        <div
                          class="d-flex"
                          style="
                            margin-top: 15px;
                            width: 100%;
                            border: 1px solid #593bfd;
                            border-radius: 4px;
                          "
                        >
                          <div
                            class="flex-grow-1"
                            style="padding: 5px 5px 0px 5px"
                            id="copyEmail"
                          >
                            {{ connectedEmail }}
                          </div>
                          <div style="margin-top: -1px" @click="copyEmail">
                            <button
                              class="newTask"
                              style="
                                cursor: pointer;
                                color: #ffffff;
                                background-color: #5445f3;
                                width: 50px;
                              "
                              title="Copy Email"
                            >
                              <!-- <i
                                class="far fa-copy"
                                style="font-size: 18px"
                              ></i> -->
                              <img src="static/img/emailCopy.svg" />
                            </button>
                          </div>
                        </div>
                        <div style="margin-top: 15px">
                          <div class="connectedEmailText" style="opacity: 1">
                            Steps to activate for
                          </div>
                        </div>
                        <div class="d-flex" style="margin-top: 15px">
                          <div style="height: 25px; width: 25px">
                            <a
                              href="https://fiifi.co/email-forwarding/"
                              target="_blank"
                            >
                              <img
                                src="static/img/google-icon.png"
                                height="100%"
                                width="100%"
                              />
                            </a>
                          </div>
                          <div
                            style="height: 25px; width: 25px; margin-left: 25px"
                            title="Comming Soon"
                          >
                            <!-- <a
                              href="https://fiifi.co/email-forwarding/"
                              target="_blank"
                            > -->
                            <img
                              src="static/img/disabledOutlookIcon.svg"
                              height="100%"
                              width="100%"
                            />
                            <!-- </a> -->
                          </div>
                          <div
                            style="height: 25px; width: 25px; margin-left: 25px"
                            title="Comming Soon"
                          >
                            <!-- <a
                              href="https://fiifi.co/email-forwarding/"
                              target="_blank"
                            > -->
                            <img
                              src="static/img/disabledYahooIcon.svg"
                              height="100%"
                              width="100%"
                            />
                            <!-- </a> -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="margin-top: 30px; margin-bottom: 20px"
      v-if="teamArray.length > 0"
    >
      <div class="row ml-0 mr-0 w-100">
        <div class="workspaceProfileTeamTitle">Team</div>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div
        class="col-3 pl-0"
        v-for="(item, index) in teamArray"
        :key="index"
        style="padding-right: 30px"
      >
        <div class="workspaceTeamCardsMainLayout">
          <div class="d-flex">
            <div style="padding: 15px 20px 15px 10px">
              <div class="workspaceProfileTeamImage">
                <b-avatar
                  :text="item.name.charAt(0).toUpperCase()"
                  class="align-baseline referrerAvatar"
                  :style="`background:${pickBackgroundColor(
                    item.name
                  )};min-width:100%;min-height:100%;border-radius:50%;`"
                  :src="item.image"
                ></b-avatar>
              </div>
            </div>
            <div style="width: 100%">
              <div
                style="
                  padding-top: 31px;
                  padding-bottom: 3px;
                  padding-right: 20px;
                "
              >
                <div class="workspaceProfileTeamName">{{ item.name }}</div>
              </div>
              <div style="padding-bottom: 3px">
                <div class="workspaceProfileTeamRole">{{ item.role }}</div>
              </div>
              <div>
                <div class="workspaceProfileTeamRole">
                  Last login : {{ item.lastLoggedIn }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      left
      title
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="300px"
      style="margin: 0 auto"
      :visible.sync="showLoader"
      class="loadingModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div style="text-align: center">
        <div>
          <b-spinner
            style="width: 7rem; height: 7rem; color: #5445f3"
            class="mt-5"
            label="Large Spinner"
          ></b-spinner>
        </div>
        <div style="margin-top: 15px; color: #000">Loading...</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import NavbarNew from "../Layout/NavbarNew";
import { mapGetters } from "vuex";
import { precisionNumberForamtter } from "./../../../util";
import config from "../../../../config/settings";
import api from "../../../axios_api";
import moment from "moment";
import { pickBackgroundColor } from "../../../util/index";
import { Dialog } from "element-ui";
export default {
  name: "workspaceProfile",
  components: {
    [NavbarNew.name]: NavbarNew,
    [Dialog.name]: Dialog,
  },
  computed: {
    ...mapGetters("workspace", ["currentWorkspaceProfile"]),
    backgroundColor() {
      if (
        this.currentWorkspaceProfile &&
        this.currentWorkspaceProfile.hasOwnProperty("workspace_type") &&
        this.currentWorkspaceProfile.workspace_type == "General Partner"
      ) {
        return "#78DE87;";
      } else {
        return "#FFD562";
      }
    },
    avatarText() {
      if (
        this.currentWorkspaceProfile &&
        this.currentWorkspaceProfile.hasOwnProperty("workspace_title") &&
        this.currentWorkspaceProfile.workspace_title.length > 0
      ) {
        let text = this.currentWorkspaceProfile.workspace_title.split(" ");
        text =
          text.length > 1
            ? `${text[0].charAt(0)}${text[1].charAt(0)}`
            : text[0].charAt(0);

        return text;
      } else {
        return "U";
      }
    },
    boxesArray() {
      let array = [];
      if (
        this.currentWorkspaceProfile &&
        this.currentWorkspaceProfile.hasOwnProperty("workspace_type") &&
        this.currentWorkspaceProfile.workspace_type == "General Partner"
      ) {
        array = [
          {
            label: "Portfolio Value",
            value:
              this.currentWorkspaceProfile &&
              this.currentWorkspaceProfile.hasOwnProperty("portfolio_value")
                ? `$${precisionNumberForamtter(
                    this.currentWorkspaceProfile.portfolio_value,
                    1
                  )}`
                : "$0",
          },
          {
            label: "Investments",
            value:
              this.currentWorkspaceProfile &&
              this.currentWorkspaceProfile.hasOwnProperty("investCount") &&
              this.currentWorkspaceProfile.investCount
                ? this.currentWorkspaceProfile.investCount
                : 0,
          },
          {
            label: "Exits",
            value:
              this.currentWorkspaceProfile &&
              this.currentWorkspaceProfile.hasOwnProperty("exits") &&
              this.currentWorkspaceProfile.exits
                ? this.currentWorkspaceProfile.exits
                : 0,
          },
        ];
      } else if (
        this.currentWorkspaceProfile &&
        this.currentWorkspaceProfile.hasOwnProperty("workspace_type") &&
        this.currentWorkspaceProfile.workspace_type == "Limited Partner"
      ) {
        array = [
          {
            label: "Fund Size",
            value:
              this.currentWorkspaceProfile.thesisData &&
              this.currentWorkspaceProfile.thesisData.size
                ? `$${precisionNumberForamtter(
                    this.currentWorkspaceProfile.thesisData.size,
                    1
                  )}`
                : "$0",
          },
          {
            label: "Value Of Portfolio",
            value:
              this.currentWorkspaceProfile.lpFundAdditionalData &&
              this.currentWorkspaceProfile.lpFundAdditionalData
                .fund_value_of_portfolio
                ? `$${precisionNumberForamtter(
                    this.currentWorkspaceProfile.lpFundAdditionalData
                      .fund_value_of_portfolio,
                    1
                  )}`
                : `$0`,
          },
          {
            label: "DPI",
            value:
              this.currentWorkspaceProfile.lpFundAdditionalData &&
              this.currentWorkspaceProfile.lpFundAdditionalData.fund_dpi
                ? this.currentWorkspaceProfile.lpFundAdditionalData.fund_dpi
                : 0,
          },
        ];
      } else {
        array = [
          {
            label: "Portfolio Value",
            value:
              this.currentWorkspaceProfile &&
              this.currentWorkspaceProfile.hasOwnProperty("portfolio_value")
                ? `$${precisionNumberForamtter(
                    this.currentWorkspaceProfile.portfolio_value,
                    1
                  )}`
                : "$0",
          },
          {
            label: "Portfolio",
            value:
              this.currentWorkspaceProfile &&
              this.currentWorkspaceProfile.hasOwnProperty("portfolio_length") &&
              this.currentWorkspaceProfile.portfolio_length
                ? this.currentWorkspaceProfile.portfolio_length
                : 0,
          },
          {
            label: "Diligence",
            value:
              this.currentWorkspaceProfile &&
              this.currentWorkspaceProfile.hasOwnProperty("diligence_length") &&
              this.currentWorkspaceProfile.diligence_length
                ? this.currentWorkspaceProfile.diligence_length
                : 0,
          },
        ];
      }
      return array;
    },
    workspaceProfileTableFields() {
      let workspaceData = JSON.parse(
        JSON.stringify(this.currentWorkspaceProfile)
      );
      return [
        // {
        //   label: "Workspace Name",
        //   value:
        //     workspaceData &&
        //     workspaceData.hasOwnProperty("workspace_title") &&
        //     workspaceData.workspace_title.length > 0
        //       ? workspaceData.workspace_title
        //       : "Untitled",
        // },
        // {
        //   label: "Workspace Type",
        //   value:
        //     workspaceData &&
        //     workspaceData.hasOwnProperty("workspace_type") &&
        //     workspaceData.workspace_type.length > 0
        //       ? workspaceData.workspace_type
        //       : "Direct Investment",
        // },
        // {
        //   label: "Role",
        //   value:
        //     workspaceData &&
        //     workspaceData.hasOwnProperty("role") &&
        //     workspaceData.role.length > 0
        //       ? this.getRole(workspaceData.role, false)
        //       : "-",
        // },
        {
          label: "Role Description",
          value:
            workspaceData &&
            workspaceData.hasOwnProperty("role") &&
            workspaceData.role.length > 0
              ? this.getRole(workspaceData.role, true)
              : "-",
        },
        {
          label: "Sector",
          value:
            workspaceData &&
            workspaceData.hasOwnProperty("workspace") &&
            workspaceData.workspace.hasOwnProperty("sectors") &&
            workspaceData.workspace.sectors.length > 0
              ? workspaceData.workspace.sectors.toString().replaceAll(",", ", ")
              : "-",
        },
        {
          label: "Stages",
          value:
            workspaceData &&
            workspaceData.hasOwnProperty("workspace") &&
            workspaceData.workspace.hasOwnProperty("stages") &&
            workspaceData.workspace.stages.length > 0
              ? workspaceData.workspace.stages.toString().replaceAll(",", ", ")
              : "-",
        },
        {
          label: "Plan",
          value: this.planString,
        },
        // {
        //   label: "Forward email integration",
        //   value: `<button class="newTask" disabled style="cursor: not-allowed; color: rgb(103, 103, 103); border-color: rgb(103, 103, 103);" title="Coming Soon">
        //   <!-- <a href="https://google.com" target="_blank"> -->
        //     <img src="static/img/emailSetup.svg" class="" style="opacity:0.5"/><span style="margin-left:6px;">Setup</span>
        //    <!-- </a>-->
        //   </button>`,
        // },
        {
          label: "Connected Email",
          value: `<div>
          <div class='connectedEmailText'>Like insurance for your portfolio, automatically send pitch decks, deal docs, and tax info to your fiifi workspace from outside your fiifi account and from your email. Use this unique email to share with scouts and team members.</div>
          <div class='connectedEmailText' style='margin-top:15px'>Emails that are logged to fiifi using the BCC or forwarding address will include the attachments in the email (email content coming soon!).</div>
          <div class='connectedEmailText' style='margin-top:15px'>The attached will automatically be added to the notification center, the sender to the attribution section, and added to its associated company.</div>
          <div class='d-flex' style='margin-top:15px;width:100%;border: 1px solid #593BFD;border-radius: 4px;'>
          <div class='flex-grow-1' style='padding:5px 5px 0px 5px;' id='copyEmail'>
          5f15d7f0ead5e93536b7f6ef.5f15d7f0ead5e93536b7f6f1@no-reply.fiifi-dev.co
          </div>
          <div style='margin-top: -1px;'>
          <button class="newTask" disabled style="cursor: pointer; color: #FFFFFF;background-color:#5445F3;width: 50px;" title="Copy Email" onClick='copyEmail()'>
          <i class="far fa-copy" style='font-size:18px'></i>
          </button>
          </div>
          </div>
          </div>`,
        },
      ];
    },
    planString() {
      if (this.plan == "AP") {
        return "fiifi AP - Angel Pro";
      } else if (this.plan == "PI") {
        return "fiifi PI - Portfolio Insider";
      } else if (this.plan == "IM") {
        return "fiifi IM - Investment Manager";
      } else {
        return "fiifi FREE";
      }
    },
    teamArray() {
      let array = [];
      let currentAccount = this.$route.params.account_id;
      let teamArray = JSON.parse(JSON.stringify(this.team));
      if (teamArray.length == 0) {
        return array;
      }
      teamArray.map((item) => {
        let obj = {};
        if (item && item.hasOwnProperty("account")) {
          if (
            item.account.hasOwnProperty("_id") &&
            item.account._id != currentAccount
          ) {
            obj.image =
              item.account.hasOwnProperty("image") &&
              item.account.image.length > 0
                ? item.account.image
                : "";
            obj.name =
              item.account.hasOwnProperty("firstName") &&
              item.account.hasOwnProperty("lastName")
                ? item.account.firstName != item.account.lastName
                  ? `${item.account.firstName} ${item.account.lastName}`
                  : item.account.firstName
                : "";
            obj.role =
              item.hasOwnProperty("role") && item.role.hasOwnProperty("name")
                ? item.role.name.length > 0
                  ? item.role.name
                  : "-"
                : "-";
            obj.lastLoggedIn =
              item.account.hasOwnProperty("last_logged_in") &&
              item.account.last_logged_in.length > 0
                ? this.moment(item.account.last_logged_in).format("MM-DD-YYYY")
                : this.moment(new Date()).format("MM-DD-YYYY");
            array.push(obj);
          }
        }
      });
      return array;
    },
    moment() {
      return moment;
    },
    avatarLogo() {
      let logo = "";
      if (
        this.currentWorkspaceProfile &&
        this.currentWorkspaceProfile.hasOwnProperty("workspace") &&
        this.currentWorkspaceProfile.workspace.hasOwnProperty("logo") &&
        this.currentWorkspaceProfile.workspace.logo.length > 0
      ) {
        logo = this.currentWorkspaceProfile.workspace.logo;
      }
      this.showLoader = false;
      return logo;
    },
    connectedEmail() {
      return `${this.$route.params.account_id}+${this.currentWorkspaceProfile.workspace_id}@${config.EMAIL_FORWARDING_DOMAIN}`;
    },
    workspaceFields() {
      let workspaceData = JSON.parse(
        JSON.stringify(this.currentWorkspaceProfile)
      );
      return [
        {
          label: "Workspace Name",
          value:
            workspaceData &&
            workspaceData.hasOwnProperty("workspace_title") &&
            workspaceData.workspace_title.length > 0
              ? workspaceData.workspace_title
              : "Untitled",
        },
        {
          label: "Workspace Type",
          value:
            workspaceData &&
            workspaceData.hasOwnProperty("workspace_type") &&
            workspaceData.workspace_type.length > 0
              ? workspaceData.workspace_type
              : "Direct Investment",
        },
        {
          label: "Role",
          value:
            workspaceData &&
            workspaceData.hasOwnProperty("role") &&
            workspaceData.role.length > 0
              ? this.getRole(workspaceData.role, false)
              : "-",
        },
      ];
    },
  },
  data() {
    return {
      config,
      plan: "",
      team: [],
      showLoader: false,
    };
  },
  methods: {
    getRole(role, description) {
      if (!this.config.ROLE.hasOwnProperty(role)) {
        return "-";
      }
      return description
        ? this.config.ROLE[role].description
        : this.config.ROLE[role].label;
    },
    pickBackgroundColor: pickBackgroundColor,
    handleFile(e) {
      const self = this;
      let image = event.target.files[0];
      if (!image) return;
      this.showLoader = true;
      let imageType = image.type && image.type.length > 0 ? image.type : "";
      let imageValidation =
        imageType.length > 0 &&
        (imageType == "image/jpeg" ||
          imageType == "image/png" ||
          imageType == "image/gif" ||
          imageType == "image/jpg" ||
          imageType == "image/svg" ||
          imageType == "image/svg+xml")
          ? true
          : false;
      if (!imageValidation) {
        this.showLoader = false;
        this.$toaster.error(
          `File not supported. We only support jpeg, jpg, png, svg and gif images.`
        );
        return;
      }
      let filePayload = {
        files: [],
        data: [],
      };
      filePayload.files.push(image);
      filePayload.data.push({
        workspace: this.currentWorkspaceProfile.workspace_id,
        account: this.$route.params.account_id,
        logo:
          this.currentWorkspaceProfile &&
          this.currentWorkspaceProfile.hasOwnProperty("workspace") &&
          this.currentWorkspaceProfile.workspace.hasOwnProperty("logo") &&
          this.currentWorkspaceProfile.workspace.logo.length > 0
            ? this.currentWorkspaceProfile.workspace.logo
            : "",
        key:
          this.currentWorkspaceProfile &&
          this.currentWorkspaceProfile.hasOwnProperty("workspace") &&
          this.currentWorkspaceProfile.workspace.hasOwnProperty("s3Key") &&
          this.currentWorkspaceProfile.workspace.s3Key.length > 0
            ? this.currentWorkspaceProfile.workspace.s3Key
            : "",
      });
      this.$store
        .dispatch("workspace/apiPostWorkspaceLogo", filePayload)
        .then((data) => {
          this.$store.dispatch("workspace/apiFetchworkspaces");
          this.currentWorkspaceProfile.workspace = data.data.encrypt.success[0];
          self.$toaster.success("Saved Successfully");
        })
        .catch((error) => {
          console.log("error during workspace profile upload", error);
          this.$toaster.error(
            "Something went wrong. Please try again after some time"
          );
          this.showLoader = false;
        });
    },
    copyEmail() {
      this.$clipboard(this.connectedEmail);
      this.$toaster.success("Email Copied to clipboard");
    },
  },
  mounted() {
    if (
      this.currentWorkspaceProfile &&
      this.currentWorkspaceProfile.workspace_id
    ) {
      let url = `/get/workspace/planFeatures/${this.currentWorkspaceProfile.workspace_id}`;
      api
        .get(url)
        .then((data) => {
          let response = data.data.encrypt.success[0];
          this.plan = response.plan ? response.plan : "";
        })
        .catch((err) => {
          console.error(
            `Error during plan feature fetch from workspace profile: ${err}`
          );
        });
      let teamUrl = `${this.$route.params.account_id}/${this.currentWorkspaceProfile.workspace_id}/getallUsers`;
      api
        .get(teamUrl)
        .then((data) => {
          this.team = data.data.encrypt.success;
        })
        .catch((err) => {
          console.error(
            `Error during team fetch from workspace profile: ${err}`
          );
        });
    }
  },
};
</script>
<style>
.workspaceProfileLayout {
  background: #fcfcfc 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-left: 60px;
}
.workspaceProfileLogoSection {
  height: 100%;
  /* height: 360px; */
  /* overflow: auto; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000001a;
  opacity: 1;
}

.workspaceProfileLogo {
  width: 204px;
  height: 204px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

.profileAvatar .b-avatar-text {
  font-size: 70px !important;
  color: #000000cc;
}

.workspaceProfileBoxesOuterLayout {
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;
}

.workspaceProfileBoxesInnerLayout {
  border: 1px solid #7070704d;
  height: 65px;
}

.workspaceTeamCardsMainLayout {
  /* width: 293px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000001a;
  opacity: 1;
  /* margin-right: 35px; */
  margin-bottom: 30px;
}

.workspaceProfileTeamImage {
  width: 90px;
  height: 90px;
}

.workspaceProfileLogoEditIconLayout {
  width: 39px;
  height: 39px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000029;
  opacity: 1;
  border-radius: 50%;
}

.workspaceProfileLogoEditIconInnerLayout {
  color: rgb(89, 59, 253);
  display: flex;
  justify-content: center;
  padding-top: 12px;
}

.workspaceProfileEditIconOuterLayout {
  position: absolute;
  z-index: 1;
  top: 177px;
  right: 150px;
}
</style>